import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
// import { Container } from './styles';

const config = {
  types: [],
  modifiers: [],
  state: []
}

function CopyContainer(props) {
  const { value } = props
  return (
    <div
      className={`${resolveProps(props, config, 'CopyContainer')}`}
      onClick={() => {
        navigator.clipboard.writeText(value)
      }}
    >
      <div className="mdn-CopyContainer-content">
        <p
          className="mdn-CopyContainer-content-toCopy mdn-Heading mdn-Heading--xxs"
          mdn-copycontainer-value={value}
          mdn-copycontainer-after="Clique para copiar"
        >
          {value}
        </p>
      </div>
      <div className="mdn-CopyContainer-icon">
        <span className="mdn-Icon-duplicar mdn-Icon--md"></span>
      </div>
    </div>
  )
}

export default CopyContainer

CopyContainer.propTypes = {
  value: PropTypes.string.isRequired
}
